import { ChoiceList } from '@shopify/polaris';
import { useMemo, useState } from 'react';
import type { WidgetConfig } from '../../store/widget.store';
import { pagePlacements } from '../../constants/lists';

type Props = {
    position: WidgetConfig['placements'][number]['position'];
    page: WidgetConfig['placements'][number]['page'];
    onChange: (
        page: WidgetConfig['placements'][number]['page'],
        placement: { position: WidgetConfig['placements'][number]['position'] }
    ) => void;
    disabled?: boolean;
};

export function PlacementComponent({ position, page, onChange, disabled }: Readonly<Props>) {
    const [selected, setSelected] = useState<string[]>([position]);
    const handleChange = (value: string[]) => {
        if (value.length > 0) {
            setSelected(value);
            onChange(page, { position: value[0] as WidgetConfig['placements'][number]['position'] });
        }
    };

    const choices = useMemo(() => {
        if (page === 'product') {
            return pagePlacements;
        } else {
            return pagePlacements.filter(v => v.value !== 'add_to_cart');
        }
    }, []);

    return (
        <ChoiceList
            title=""
            choices={choices}
            selected={selected}
            allowMultiple={false}
            onChange={handleChange}
            disabled={disabled}
        />
    );
}
